// 深捷旅酒店直连
export const sjlHotelRouter = [
  {
    path: '/service/sjlHotel/product',
    name: 'SjlHotelProductList',
    component: () => import('@/views/service/serviceProvider/sjlHotel/SjlHotelProductList'),
    meta: {
      title: '同步产品',
      keepAlive: false
    }
  },
  {
    path: '/service/sjlHotel/order',
    name: 'SjlHotelOrderList',
    component: () => import('@/views/service/serviceProvider/sjlHotel/SjlHotelOrderList'),
    meta: {
      title: '订单直连',
      keepAlive: false
    }
  },
  {
    path: '/service/sjlHotel/apiConfigure',
    name: 'SjlHotelApiConfigure',
    component: () => import('@/views/service/serviceProvider/sjlHotel/SjlHotelApiConfigure'),
    meta: {
      title: 'API配置',
      keepAlive: false
    }
  },
  {
    path: '/service/sjlHotel/syncRule',
    name: 'SjlHotelSyncRule',
    component: () => import('@/views/service/serviceProvider/sjlHotel/SjlHotelSyncRule'),
    meta: {
      title: '同步规则',
      keepAlive: false
    }
  }
]
